import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24fbda49&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=24fbda49&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fbda49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24fbda49')) {
      api.createRecord('24fbda49', component.options)
    } else {
      api.reload('24fbda49', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=24fbda49&scoped=true", function () {
      api.rerender('24fbda49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/driver-notification/index.vue"
export default component.exports